import { useErpStudentSurveyResponsesQuery } from 'core/graphql';

/**
 * Spec 0038 — one student's answers, for their ERP card.
 *
 * The LMS twin (`mySubmittedSurveys`) deliberately takes no studentId at
 * all; this is the separate, ERP-gated read. It is also the most sensitive
 * payload in the domain — a named student's verbatim opinion of a named
 * teacher — so the backend gates it to survey managers, tighter than the
 * aggregates. A role without access gets an Apollo error rather than an
 * empty list; `StudentDetail` hides the tab for those roles
 * (`useStudentPermissions.canReadStudentSurveys`) and the tab itself still
 * renders an explicit denial if one slips through.
 */
export const useStudentSurveyHistory = (
  studentId?: string,
  options?: { surveyId?: string; groupId?: string; skip?: boolean },
) => {
  const { data, loading, error } = useErpStudentSurveyResponsesQuery({
    variables: {
      studentId: studentId as string,
      surveyId: options?.surveyId,
      groupId: options?.groupId,
      includePending: true,
    },
    skip: !studentId || options?.skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    history: data?.studentSurveyResponses || undefined,
    loading,
    error,
  };
};
